export default {
  // 右键菜单选项
  viewdetails: "展开详情",
  noteNode: "备注节点",
  copyAddress: "复制地址",
  newCanvas: "新建画布",
  tagSettings: "标签设置",
  addTag: "添加标签",
  modifyTag: "修改标签",
  deleteTag: "删除标签",
  joinSurvey: "加入调证",
  ordinarySurvey: "普通调证",
  keySurvey: "重点调证",
  joinMonitoring: "加入监控",
  joinBoard: "加入看板",
  exchangeExpansion: "交易所扩展",
  aiModel: "AI模型：",
  firstFeeTraceability: "首笔手续费追溯",
  multilayerTraceability: "多层追溯",
  transactionPathAnalysis: "交易路径分析",
  addToStart: "添加到起点",
  addToEnd: "添加到终点",
  relatedFeeModel: "关联手续费模型",
  tornadoModel: "龙卷风模型",
  newOldStopModel: "新启旧停模型",
  singleChannelModel: "单通道中转模型",
  Traceability:'混币追踪',
  // 批量操作
  batchNote: "批量备注",
  batchCopy: "批量复制",
  batchAddTag: "批量添加标签",
  batchJoinSurvey: "批量加入调证",
  batchJoinBoard: "批量加入看板",
  directAssociation: "直接关联",
  batchExpansion: "批量扩展",
  batchQueryBalance: "批量查询余额",
  batchDeleteNode: "批量删除节点",
  commonTradingCounterpart: "共同交易对手",
  deleteNode: "删除节点",
  // 快捷键
  altV: "alt+v/⌥+v",
  ctrlC: "ctrl+C/⌘+C",
  altG: "alt+g/⌥+g",
  ctrlM: "ctrl+M/⌘+M",
  ctrlR: "ctrl+R/⌘+R",
  enter: "enter/return",

  // 错误提示

  cannotSelectBothTypes: "不能同时选择调证节点和普通节点",
  aggregateNodeNotSupported: "聚合点不支持该操作！",
  notSupportMultipleTypes: "不支持同时操作多个类型的节点",
  platformException: "平台异常",
  tip: "提示",
  noRelatedData: "很抱歉，关联查询结果中没有找到相关数据",
  noMoreBranches: "已无更多分支或该数据源配置中暂无结果",
  mixPlatformNodeNotSupported: "混币平台节点不支持操作，请在混币交易详情页面进行混币追踪",
  aggregationPointNotSupported: "跨链平台节点不支持操作，请在跨链交易详情页面进行跨链追踪",

  // 保存相关
  saveInfo: "保存信息",
  modifyInfo: "修改信息",

  // vis-network 本地化
  edit: "编辑",
  del: "删除当前节点或关系",
  back: "返回",
  addNode: "添加节点",
  addEdge: "添加连线",
  editNode: "编辑节点",
  editEdge: "编辑连线",
  addDescription: "点击空白处可添加节点",
  edgeDescription: "点击某个节点拖拽连线可连接另一个节点",
  editEdgeDescription: "可拖拽连线改变关系",
  createEdgeError: "无法将边连接到集群",
  deleteClusterError: "无法删除集群.",
  editClusterError: "无法编辑群集'",
};
